import { Modal } from '@mui/material';
import './AgModal.scss';
import { CloseIcon } from 'app/agriculture/icons';
import { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
    children: ReactNode;
    open: boolean;
    className?: string;
    title: ReactNode;
}

export function AgModal({ open, className, children, title }: Props) {
    return (
        <Modal open={open}>
            <div className={classNames('AgModal', className)}>
                <div className={'AgModal__container'}>
                    <div className={'AgModal__header'}>{title}</div>
                    {children}
                </div>
            </div>
        </Modal>
    );
}

export function AgModalCloseButton({ onClick }: { onClick: () => void }) {
    return (
        <div
            className={'AgModal__header__close_button'}
            data-cy={'AgModal__header__close_button'}
            // size={24}
            onClick={onClick}
        >
            <CloseIcon />
        </div>
    );
}
